import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { AssigneePicker } from "~/components/AssigneePicker";
import { getProjectTemplateById } from "~/store/selectors/selector.projectTemplates";
import { getActiveUsersMembersByUserIdsSelector } from "~/store/selectors/selector.users";
import { resolvedMembersForAssigneePicker } from "../../utils";

export const TemplateSubtaskAssigneePicker = ({ subtask, isHiddenFromClients, onChange, ...rest }) => {
  const template = useSelector((state) => getProjectTemplateById(state, subtask?.template_id));
  const members = useSelector((state) => getActiveUsersMembersByUserIdsSelector(state, template?.get("members") || []));

  const handleChange = (id) => {
    onChange({ assignee_id: id });
  };

  return (
    <AssigneePicker
      {...rest}
      onChange={handleChange}
      options={resolvedMembersForAssigneePicker(members, isHiddenFromClients)}
      assigneeId={subtask.assignee_id > 0 ? subtask.assignee_id : null}
    />
  );
};

TemplateSubtaskAssigneePicker.propTypes = {
  subtask: PropTypes.object.isRequired,
  isHiddenFromClients: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};
